import uniqueId from '@form-create/utils/lib/unique';
var label = '开关';
var name = 'switch';
export default {
  icon: 'icon-switch',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {}
    };
  },
  props: function props() {
    return [{
      type: 'switch',
      field: 'disabled',
      title: '是否禁用'
    }, {
      type: 'inputNumber',
      field: 'width',
      title: '宽度（px）'
    }, {
      type: 'input',
      field: 'activeText',
      title: 'switch 打开时的文字描述'
    }, {
      type: 'input',
      field: 'inactiveText',
      title: 'switch 关闭时的文字描述'
    }, {
      type: 'input',
      field: 'activeValue',
      title: 'switch 打开时的值'
    }, {
      type: 'input',
      field: 'inactiveValue',
      title: 'switch 关闭时的值'
    }, {
      type: 'input',
      field: 'activeColor',
      title: 'switch 打开时的背景色'
    }, {
      type: 'input',
      field: 'inactiveColor',
      title: 'switch 关闭时的背景色'
    }];
  }
};